import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../types/store';

import { isCurrentUserProfileOwner } from '../../../selectors/users';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';
import { getUsersByIds } from '@wix/da-shared-react/pkg/redux/users/selectors';
import { VISITOR_IDS_STREAM } from '../../../streams';
import { Props } from './RecentVisitors';

type StateProps = Pick<Props, 'visitors' | 'isOwner' | 'hasMore' | 'isFetching'>;
type DispatchProps = Pick<Props, 'fetchMore'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const visitors = getUsersByIds(
    state,
    streamSelectors.getItems(state, VISITOR_IDS_STREAM)
  );
  const hasMore = streamSelectors.hasMore(state, VISITOR_IDS_STREAM);
  const isFetching = streamSelectors.isFetching(state, VISITOR_IDS_STREAM);
  const isOwner = isCurrentUserProfileOwner(state);
  return { visitors, isOwner, hasMore, isFetching };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  fetchMore: () => dispatch(withOffset.actions.fetch(VISITOR_IDS_STREAM)),
});

export default connect(mapStateToProps, mapDispatchToProps);
